<template>
  <v-app>
    <NavBar />
    <router-view  />
    <ProgressBar />
    <ScrollUp v-if="showScroll && this.$vuetify.breakpoint.mdAndUp" />
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import ScrollUp from "@/components/ScrollUp.vue";
import ProgressBar from "@/components/ProgressBar.vue";

export default {
  name: "Portfolio-Joseph-Perrin",
  data() {
    return {
      showScroll: false
    }
  },
  components: {
    NavBar,
    ScrollUp,
    ProgressBar,
  },
  created() {
    // window.addEventListener(
    //   "deviceorientation",
    //   this.detectionLeftOrRightHanded,
    //   true
    // );
    window.addEventListener("scroll", this.showScrollUp);
  },
  methods: {
    // To call once, just when the app is created to define the hand of the user
    // detectionLeftOrRightHanded(event) {
    // var absolute = event.absolute;
    // var alpha = event.alpha;
    // var beta = event.beta;
    //   var gamma = event.gamma;
    //   if (gamma < 0) {
    //     this.hand = "left";
    //   } else {
    //     this.hand = "right";
    //   }
    //   window.removeEventListener(
    //     "deviceorientation",
    //     this.detectionLeftOrRightHanded,
    //     true
    //   );
    // },
    showScrollUp() {
      if (window.scrollY < 500) {
        this.showScroll = false;
      } else {
        this.showScroll = true;
      }
    },
  },
};
</script>

<!-- General style -->
<style></style>
